// @flow
import React from 'react';
import PropTypes from 'prop-types';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Button from '@material-ui/core/Button';
import {Link} from 'react-router-dom';

import type {Node} from 'react';
// import {colors} from '../../assets/styles/colors';

import type {ButtonProps} from '@material-ui/core';

type Props = {
  className?: string,
  color?: string,
  children?: Node,
  to?: string,
} & ButtonProps;

const useStyles = makeStyles(theme => ({
  default: {
    textTransform: 'none',
    borderRadius: 32,
    whiteSpace: 'nowrap',
    minWidth: 'unset',
  },
}));

function CustomButton(props: Props, ref: any) {
  const {className, color, children, to, ...otherProps} = props;

  const classes = useStyles();

  return (
    <Button
      component={to ? Link : undefined}
      to={to}
      color={color ? color : 'primary'}
      className={`${classes.default} ${className ? className : ''}`}
      disableElevation
      ref={ref}
      {...otherProps}
    >
      {children}
    </Button>
  );
}

export default React.forwardRef<Props, typeof CustomButton>(CustomButton);

CustomButton.propTypes = {
  className: PropTypes.string,
  color: PropTypes.string,
  children: PropTypes.any,
  to: PropTypes.string,
};
